export default {"src":"/_next/static/media/DE.d9f8e6b3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};